import { Remover } from "./Remover";
export async function loadExternalRemoveInteraction(engine, refresh = true) {
    await engine.addInteractor("externalRemove", (container) => new Remover(container), refresh);
}
export * from "./Options/Classes/Remove";
export * from "./Options/Interfaces/IRemove";
